import { requestJson } from "./apiClient";

const BASE = "/api/reports/transport";

function buildSearch(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") {
      search.set(key, String(value));
    }
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
}

export async function fetchTransportReportTemplates(options = {}) {
  return requestJson(`${BASE}/templates`, { signal: options.signal });
}

export async function generateTransportReport(payload, options = {}) {
  return requestJson(`${BASE}/generate`, {
    method: "POST",
    body: payload,
    signal: options.signal,
  });
}

export async function fetchTransportReports(params = {}, options = {}) {
  return requestJson(`${BASE}${buildSearch(params)}`, { signal: options.signal });
}

export async function fetchTransportReport(reportKey, options = {}) {
  return requestJson(`${BASE}/${encodeURIComponent(reportKey)}`, { signal: options.signal });
}

export async function exportTransportReport(reportKey, exportType = "json", options = {}) {
  const response = await fetch(`${BASE}/${encodeURIComponent(reportKey)}/export`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ exportType }),
    signal: options.signal,
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || "Export failed.");
  }
  const blob = await response.blob();
  const disposition = response.headers.get("Content-Disposition") || "";
  const match = disposition.match(/filename="([^"]+)"/);
  return {
    blob,
    filename: match?.[1] || `${reportKey}.${exportType}`,
    contentType: response.headers.get("Content-Type"),
  };
}

export async function fetchAdminTransportReports(params = {}, options = {}) {
  return requestJson(`/api/admin/reports/transport${buildSearch(params)}`, {
    signal: options.signal,
  });
}

export async function updateAdminTransportReportTemplate(templateKey, payload, options = {}) {
  return requestJson(`/api/admin/reports/templates/${encodeURIComponent(templateKey)}`, {
    method: "PATCH",
    body: payload,
    signal: options.signal,
  });
}
